<div id="host">
  <h2>{{'menu-compromise-reports' | translate}}</h2>
  <div class="filters d-flex flex-wrap">
    <app-datepicker style="margin-left: 2%" [stampdebut]="filtersActive().from" [stampfin]="filtersActive().to"
      [attestation]="false" (myDatePicker)="searchByTimestamp($event)"></app-datepicker>

    <app-filters-ac [defaultFilter]="filtersActive()" [objetAC]="promiseResult"
      (applyFilter)="searchRequestFilters($event)"></app-filters-ac>
    <button (click)="resetAll()" type="button" class="reset"></button>
  </div>
  @if (awaitChargementListe() && !loadingOerror()) {
  <div class="d-flex flex-row align-items-start canv">
    <div class="canevasListe d-flex flex-column">
      <div class="d-flex justify-content-between flex-row">
        @if (!searchmodel() && filtersActive().from && filtersActive().to) {
        <h3>{{'compromise-reports-title-h2' | translate}} {{dateRangeTitle()}}</h3>
        <h3 class="datetotitle">
          {{compromiseDateRange()}}
        </h3>
        }
        @if (searchmodel() && searchmodel().length < 30) { <h3>{{'attestations-title-search-h2' | translate}}
          {{searchmodel()}}</h3>
          } @else {
          @if (searchmodel() && searchmodel().length > 30) {
          <h3 placement="top" ngbTooltip="{{searchmodel()}}">
            {{'attestations-title-search-h2' | translate}} {{formatId(searchmodel())}}
          </h3>
          }
          }
          @if (searchmodel() && listBorn() && listBorn().length > 0) {
          <h3 class="datetotitle">
            {{compromiseDateRange()}}
          </h3>
          }
      </div>
      <div class="d-flex flex-wrap justify-content-center">
        <h4 class="result">{{promiseResult?.totalNbRows}} {{'results' | translate}}</h4>
      </div>
      @if(promiseResult && awaitChargementListe()){
      <ngb-pagination [page]="page()" [maxSize]="4" [pageSize]="pageSize()" (pageChange)="nextPage($event)"
        [collectionSize]="promiseResult.totalNbRows" [rotate]="true" [ellipses]="false" [boundaryLinks]="true">
      </ngb-pagination>
      }
      <ul>
        @for (compro of listBorn() | existingReports; track compro.id) {
        <li class="d-flex flex-row align-items-center elem" type="button" [class.actif]="compro === comproCourante()"
          (click)="detectorsList = true; setComproSelectionnee(compro); scroolTo()">
          <div class="d-flex flex-column appandId">
            @if (compro.appInfo?.appName) {
            <h4 class="elemTitre">{{formatAPPName(compro.appInfo.appName)}} - {{compro.appInfo.appVersion}}</h4>
            } @else {
            @if (compro.appInfo?.appId) {
            <h4 class="elemTitre">{{compro.appInfo.appId}} - {{compro.appInfo.appVersion}}</h4>
            }
            }
            <p>{{formatId(compro.id)}}</p>
          </div>
          <hr class="elemListehr">
          <div class="d-flex flex-column device">
            @if (compro.deviceInfo?.model) {

            <h4 class="elemTitre">{{formatName(compro.deviceInfo.model)}}</h4>
            @if (compro.deviceInfo?.manufacturer) {
            <div class="d-flex flex-row align-items-center">
              <img class="icone{{compro.deviceInfo.platformName?.toLowerCase()}}"
                src="assets/icons/logosOS/{{compro.deviceInfo.platformName?.toLowerCase()}}.svg">
              @if (compro.deviceInfo.platformName?.toLowerCase() === 'ios' ||
              compro.deviceInfo.platformName?.toLowerCase() === 'ipados') {
              <h5 class="version-os">v.{{compro.deviceInfo.apiLevel}}</h5>
              }
              @if (compro.deviceInfo.platformName?.toLowerCase() === 'android') {
              <h5 class="version-os">v.{{compro.deviceInfo.platformVersion}}</h5>
              }
            </div>
            } @else {
            <h6>Unknown OS</h6>
            }

            }
            @else if (compro.deviceInfo?.manufacturer) {
            <h4 class="elemTitre">{{formatName(compro.deviceInfo.manufacturer)}} - NA</h4>
            @if (compro.deviceInfo?.manufacturer) {
            <div class="d-flex flex-row align-items-center">
              <img class="icone{{compro.deviceInfo.platformName?.toLowerCase()}}"
                src="assets/icons/logosOS/{{compro.deviceInfo.platformName?.toLowerCase()}}.svg">
              @if (compro.deviceInfo.platformName?.toLowerCase() === 'ios' ||
              compro.deviceInfo.platformName?.toLowerCase() === 'ipados') {
              <h5 class="version-os">v.{{compro.deviceInfo.apiLevel}}</h5>
              }
              @if (compro.deviceInfo.platformName?.toLowerCase() === 'android') {
              <h5 class="version-os">v.{{compro.deviceInfo.platformVersion}}</h5>
              }
            </div>
            } @else {
            <h6>Unknown OS</h6>
            }
            } @else {
            <h4 class="elemTitre">Unknown device</h4>
            <h6>Unknown OS</h6>
            }
          </div>
          <div class="d-flex flex-column date">
            <h4 class="elemTitre">{{titrefiltreDate(compro.createdAt, today())}}</h4>
            <h5>{{timestampToDate(compro.createdAt)}}<h6>{{horaire(compro.createdAt)}}</h6>
            </h5>
          </div>
          @if (compro.bwInfo?.bwCompromiseType) {
          <div class="d-flex flex-column type">
            <h4 class="elemTitre">Type</h4>
            <img type="button" placement="top" ngbTooltip="{{tooltip(compro.bwInfo.bwCompromiseType)}}"
              src="assets/icons/ComprReport/{{formatType(compro.bwInfo.bwCompromiseType)}}.svg">
          </div>
          } @else {
          <div class="d-flex flex-column type">
            <h4 class="elemTitre">Type</h4>
            <h5 type="button" placement="top" ngbTooltip="{{'unknown-type' | translate}}" class="notype">?</h5>
          </div>
          }
          <img class="side-arrow" src="assets/icons/ComprReport/down-arrow.svg">
        </li>
        }
      </ul>
      @if (promiseResult && awaitChargementListe()) {
      <ngb-pagination [page]="page()" [maxSize]="4" [pageSize]="pageSize()" (pageChange)="nextPage($event)"
        [collectionSize]="promiseResult.totalNbRows" [rotate]="true" [ellipses]="false" [boundaryLinks]="true">
      </ngb-pagination>
      }
    </div>

    @if (comproCourante()) {
    <div class="detectorsInfos" id="detectorsInfos">
      <h3>{{'compromise-reports-title-detectors' | translate}} <span class="id">{{comproCourante()?.id}}</span></h3>
      <div class="d-flex flex-row justify-content-center legend">
        <div class="ok-state d-flex flex-row align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="15" height="15">
            <circle cx="7" cy="7" r="7" fill="#46BEAA" />
          </svg>
          <h5>{{'compro-detector-status-ok' | translate}}</h5>
        </div>
        <div class="warning-state d-flex flex-row align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="15" height="15">
            <circle cx="7" cy="7" r="7" fill="#FFEB78" />
          </svg>
          <h5>{{'compro-detector-status-warning' | translate}}</h5>
        </div>
        <div class="fatal-state d-flex flex-row align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="15" height="15">
            <circle cx="7" cy="7" r="7" fill="#DB0015" />
          </svg>
          <h5>{{'compro-detector-status-fatal' | translate}}</h5>
        </div>
      </div>
      <hr class="accordeon-hr">
      <div class="d-flex flex-wrap justify-content-center">
        @for (noms of getAllProbes(); track noms) {
        <div class="d-flex flex-column justify-content-center">
          @if (noms !== 'black&White') {
          <img id="probe-{{noms.toLowerCase()}}" class="{{statutProbe(noms)}} align-self-center"
            src="assets/icons/probesFamilies/{{noms}}.svg" width="60px" height="60px">
          } @else {
          <img id="probe-{{noms.toLowerCase()}}" class="{{statutProbe(noms)}} align-self-center"
            src="assets/icons/probesFamilies/{{noms}}.png" width="60px" height="60px">
          }
          <h4 class="text-capitalize">{{noms}}</h4>
        </div>
        }
      </div>
      <div class="d-flex justify-content-center button-details">
        <app-compromise-report-modal [listeprobes]="getAllProbes()" [comproCourante]="comproCourante()"
          (filtreApp)="filtreAppNamefromAll($event)">
        </app-compromise-report-modal>
      </div>
    </div>
    }
  </div>
  }
  @else {
  @if (loadingOerror()) {
  <app-loading-error [boolean]="true" [message]="'waiting-for-compro' | translate"></app-loading-error>
  } @else {
  @if (!awaitChargementListe() && searchmodel()) {
  <app-loading-error [boolean]="false" [search]="('component-error-search' | translate) + ' ' + searchmodel()"
    [order]="'component-compromission-search-order' | translate"></app-loading-error>
  } @else {
  @if (!awaitChargementListe() && timestampToDate(filtersActive().from) !== timestampToDate(filtersActive().to)) {
  <app-loading-error [boolean]="false"
    [search]="('component-error-search' | translate) + ' ' + timestampToDate(filtersActive().from).toLowerCase() + ' - ' + timestampToDate(filtersActive().to).toLowerCase()"
    [order]="'component-error-filter-order' | translate"></app-loading-error>
  } @else {
  <app-loading-error [boolean]="false"
    [search]="('component-error-search' | translate) + ' ' + timestampToDate(filtersActive().from).toLowerCase()"
    [order]="'component-error-filter-order' | translate"></app-loading-error>
  }
  }
  }
  }
</div>
<app-toast-component></app-toast-component>